import type { KvKeys } from '@rialtic/types'
import { featureFlags, parseAppConfig } from '@rialtic/types'

export const useAppConfiguration = () => {
  const { $groundcover } = useNuxtApp()

  const flags = useState('app-config', () => featureFlags)
  const getAllFlags = async () => {
    try {
      const keys = await $apiFetch<KvKeys[]>('/api/app-config')
      flags.value = parseAppConfig(keys) as any
    } catch (error) {
      $groundcover.captureException(error as Error, {
        function: 'inquiries/appConfig:getAll',
      })
    }
  }
  return {
    getAllFlags,
    flags,
  }
}
